import React from 'react';
import styles from './Marquee.module.css';

const items = [
  'Full-Stack Development', 'SEO Optimization', 'Google Ads',
  'Social Media Management', 'React & Next.js', 'Backend Development',
  'E-commerce Platforms', 'Website Performance', 'Google Business Profile',
  'Lead Generation', 'REST APIs', 'UI/UX Design',
];

export default function Marquee() {
  return (
    <div className={styles.wrap}>
      <div className={styles.track}>
        {[...items, ...items].map((item, i) => (
          <span key={i} className={styles.item}>
            <strong>◈</strong> {item}
          </span>
        ))}
      </div>
    </div>
  );
}
